module.exports = __webpack_public_path__ + "img/cart-recommend-illustration.f12bdcf6.svg";